import type { ReactNode } from 'react';

export const symbol_equalizer: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180.5-180.56Q160-201.13 160-230v-180q0-28.88 20.59-49.44t49.5-20.56q28.91 0 49.41 20.56Q300-438.88 300-410v180q0 28.87-20.59 49.44Q258.82-160 229.91-160t-49.41-20.56ZM479.91-160q-28.91 0-49.41-20.56Q410-201.13 410-230v-500q0-28.88 20.59-49.44t49.5-20.56q28.91 0 49.41 20.56Q550-758.88 550-730v500q0 28.87-20.59 49.44Q508.82-160 479.91-160Zm200.59-20.56Q660-201.13 660-230v-300q0-28.88 20.59-49.44t49.5-20.56q28.91 0 49.41 20.56Q800-558.88 800-530v300q0 28.87-20.59 49.44Q758.82-160 729.91-160t-49.41-20.56Z"
		/>
	</svg>
);
